<div blFocusControl shareErrorHandler shareSpaControl sharePresetJudge class='main-app l-wrapper'>

  <ng-container *ngIf="_showFrame">
    <share-header></share-header>
  </ng-container>

  <div blFocusControl class="l-main">
    <router-outlet></router-outlet>
  </div>

  <ng-container *ngIf="_showFrame">
    <share-footer></share-footer>
  </ng-container>

</div>
<bl-loading></bl-loading>
<share-print-progress></share-print-progress>
<ng-snotify></ng-snotify>
<bl-overlay-alert></bl-overlay-alert>
<bl-full-screen-notify></bl-full-screen-notify>



// WEBPACK FOOTER //
// ./src/app/app.component.html